/* eslint-disable max-len */
import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { State } from "./store";

const translations: { [lang: string]: { [key: string]: string } } = {
    ru: {
        click_to_lock: "Нажмите что бы захватить мышь",
        use_esc_key_to_unlock: "Используйте `Esc` что бы освободить",
        use_slider_to_change_sensitivity: "Используйте слайдер слева что бы изменить чувствительность",
        current_sensitivity: "Текущая чувствительность",
        hello: "Привет",
        hello_guest: "Привет, гость!",
        mobile_controls: "Мобильное управление",
        mirrored_controls: "Отразить управление",
        scale_controls: "Масштаб управления",
        enter_name_of_drive: "Введите название диска",
        ws_outdated: "Необходимо обновить DOS Браузер",
        update: "Обновить",
        preloading_sockdrive: "Загрузка (единожды)",
        filter: "Фильтр",
        add: "Добавить",
        logout: "Выйти",
        features: "Функции",
        premium: "Подписка",
        buy: "Купить",
        experimental_features: "Доступ к экспериентальным функциям",
        cloud_saves: "Облачные сохранения",
        writeable_fat32: "FAT32 диски",
        net_no_limits: "Выбор сервера для стевой игры",
        unlock_options: "Доступ ко всем настройкам",
        error: "Упс... Что-то пошло не так...",
        consult_logs: "Проверьте логи браузера",
        bundle_loading: "Загрузка бандла",
        bundle_config: "Чтение конфигурации",
        try_free: "дней бесплатно",
        upload_file: "Выбирите архив jsdos/zip что бы начать...",
        emulation_backend: "Эмуляция",
        render_backend: "Рендер",
        render_aspect: "Соотношение сторон",
        worker: "Фоновый поток",
        mouse_sensitivity: "Чувст. мыши",
        mouse_lock: "Захват мыши",
        volume: "Громкость",
        pause: "Пауза",
        dosboxconf_template: "dosbox.conf шаблон:",
        preview: "Превью",
        continue: "Продолжить",
        skip: "Пропустить",
        loading: "Загрузка",
        extract_loading: "Распаковка архива",
        extract_long_time: "Может занять длительное время, пожалуйста ждите...",
        theme: "Тема",
        create_empty: "Создать пустой бандл",
        uploading_file: "Загрузка файла",
        fs_restart: "Вы хотите пересобрать бандл используя эту FS?",
        please_wait: "Пожалуйста подождите",
        making_bundle: "Создаем бандл",
        size: "Размер",
        room: "Команта",
        server: "Сервер",
        load_by_url: "Загрузить по ссылке",
        enter_url: "Введите ссылку",
        load: "Загрузить",
        stored: "Сохраненные",
        delete: "Удалить",
        editor: "Редактор",
        download: "Скачать",
        changes: "Сохранения",
        loading_saves: "Загрузка сохранений",
        success: "Успешно",
        success_save: "Сохранено в облаке",
        warn_save_no_account: "Cохранено в браузере (вы не вошли)",
        warn_save_no_premium: "Cохранено в браузере (нет подписки)",
        warn_save_big_file: "Cохранено в браузере (большой файл)",
        unable_to_save: "Ошибка записи",
        not_premium: "Подключить подписку",
        copy_net_link: "Отправьте ссылку на подключение",
        copied: "Скопировано",
        image_rendering: "Обработка изображения",
        fix: "Исправить",
        close: "Закрыть",
        cancle: "Отказаться",
        manage: "Управлять",
        unable_to_cancle_subscription: "Не удалось отменить подписку",
        subscription_cancelled: "Подписка отменена",
        hardware: "Аппаратное ускорение",
        play: "Запустить",
        system_cursor: "Системный курсор",
        no_cloud_access: "Что бы использовать облачные сохранения, введите",
        no_cloud_access2: "ниже",
        no_cloud_access3: "Без подписки прогресс сохраняется локально в браузере и может быть потерян",
        key: "ваш ключ",
        load_archive: "Загрузить архив",
        sockdrives: "Готовые образы (sockdrive)",
        confirm_save: "Хотите сохранить прогресс?",
        save: "Сохранить",
        emulation_ended: "Эмуляция завершена",
        saving_game: "Сохранение игры...",
        sockdrive_save_in_the_middle: "Win9x безопаснее сохранять после выключении системы",
        changes_loaded: "Сохранения загружены в игру",
        error_deleting_changes: "Ошибка удаления сохранений",
        no_changes_loaded: "Нет сохранений",
        upload: "Загрузить",
        error_uploading_changes: "Ошибка загрузки сохранений",
        delete_changes_confirm: "Вы уверены что хотите удалить сохранения?",
        no_changes_to_save: "Нет изменений для сохранения",
    },
    en: {
        click_to_lock: "Click to capture mouse",
        use_esc_key_to_unlock: "Use `Esc` to unlock",
        use_slider_to_change_sensitivity: "Use slider on the left to change sensitivity",
        current_sensitivity: "Current sensitivity",
        hello: "Hello",
        hello_guest: "Hello, guest!",
        play: "Start",
        system_cursor: "System cursor",
        mobile_controls: "Mobile controls",
        mirrored_controls: "Mirror controls",
        scale_controls: "Scale controls",
        enter_name_of_drive: "Enter name of drive",
        ws_outdated: "Must update DOS Browser App",
        update: "Update",
        preloading_sockdrive: "Loading (once)",
        filter: "Filter",
        add: "Add",
        logout: "Logout",
        features: "Features",
        premium: "Subscription",
        buy: "Buy",
        experimental_features: "Access to all experimental features",
        cloud_saves: "Cloud saves",
        writeable_fat32: "Writable FAT32",
        net_no_limits: "Change the network region",
        unlock_options: "Unlock all configuration options",
        error: "Oops... Something went wrong...",
        consult_logs: "Please check browser logs",
        bundle_loading: "Bundle loading",
        bundle_config: "Reading config",
        try_free: "days for free",
        upload_file: "Select jsdos/zip file to start...",
        emulation_backend: "Emulation",
        render_backend: "Render",
        render_aspect: "Aspect",
        worker: "Worker thread",
        mouse_sensitivity: "Mouse sens...",
        mouse_lock: "Capture mouse",
        volume: "Volume",
        pause: "Pause",
        dosboxconf_template: "dosbox.conf template:",
        preview: "Preview",
        continue: "Continue",
        skip: "Skip",
        loading: "Loading",
        extract_loading: "Unpacking archive",
        extract_long_time: "Can take long time, please be patient...",
        theme: "Theme",
        create_empty: "Create empty bundle",
        uploading_file: "Uploading file",
        fs_restart: "Do you want to rebuild the bundle using this fs?",
        please_wait: "Please wait",
        making_bundle: "Creating bundle",
        size: "Size",
        room: "Room",
        server: "Server",
        load_by_url: "Load by url",
        enter_url: "Enter url",
        load: "Load",
        stored: "Stored",
        delete: "Delete",
        editor: "Editor",
        download: "Download",
        changes: "Saves",
        loading_saves: "Loading saves",
        success: "Success",
        success_save: "Saved in cloud",
        warn_save_no_account: "Saved in browser (not logged in)",
        warn_save_no_premium: "Saved in browser (no subscription)",
        warn_save_big_file: "Saved in browser (large file)",
        unable_to_save: "Unable to save",
        not_premium: "Subscribe",
        copy_net_link: "Share this link to connect",
        copied: "Copied",
        image_rendering: "Image rendering",
        fix: "Fix",
        close: "Close",
        cancle: "Cancel",
        manage: "Manage",
        unable_to_cancle_subscription: "Unable to cancel subscription",
        subscription_cancelled: "Subscription cancelled",
        hardware: "Hardware acceleration",
        no_cloud_access: "To enable cloud saves, enter",
        no_cloud_access2: "below",
        no_cloud_access3: "Without a subscription, your progress will only be saved locally in your browser and may be lost",
        key: "your key",
        load_archive: "Load archive",
        sockdrives: "Disk images (sockdrive)",
        confirm_save: "Do you want to save progress?",
        save: "Save",
        emulation_ended: "Emulation ended",
        saving_game: "Saving game...",
        sockdrive_save_in_the_middle: "Win9x is safer to save after shutting down the system",
        changes_loaded: "Changes loaded in game",
        error_deleting_changes: "Error deleting changes",
        no_changes_loaded: "No changes loaded",
        upload: "Upload",
        error_uploading_changes: "Error uploading changes",
        delete_changes_confirm: "Are you sure you want to delete saves?",
        no_changes_to_save: "No changes to save",
    },
    pt: {
        click_to_lock: "Clique para capturar o mouse",
        use_esc_key_to_unlock: "Use `Esc` para desbloquear",
        use_slider_to_change_sensitivity: "Use o slider à esquerda para alterar a sensibilidade",
        current_sensitivity: "Sensibilidade atual",
        hello: "Olá",
        hello_guest: "Olá, convidado!",
        play: "Iniciar",
        system_cursor: "Cursor do sistema",
        mobile_controls: "Controles móveis",
        mirrored_controls: "Controles espelhados",
        scale_controls: "Escalar controles",
        enter_name_of_drive: "Digite o nome da unidade",
        ws_outdated: "Você precisa atualizar o aplicativo DOS Browser",
        update: "Atualizar",
        preloading_sockdrive: "Carregando",
        filter: "Filtrar",
        add: "Adicionar",
        logout: "Sair",
        features: "Recursos",
        premium: "Assinatura",
        buy: "Comprar",
        experimental_features: "Acesso a todos os recursos experimentais",
        cloud_saves: "Salvamentos em nuvem",
        writeable_fat32: "FAT32 gravável",
        net_no_limits: "Alterar a região da rede",
        unlock_options: "Desbloquear todas as opções de configuração",
        error: "Oops... Algo deu errado...",
        consult_logs: "Por favor, verifique os logs do navegador",
        bundle_loading: "Carregando pacote",
        bundle_config: "Lendo configuração",
        try_free: "dias grátis",
        upload_file: "Selecione um arquivo jsdos/zip para iniciar...",
        emulation_backend: "Emulador",
        render_backend: "Renderização",
        render_aspect: "Aspecto",
        worker: "Thread de trabalho",
        mouse_sensitivity: "Sensibilidade do mouse...",
        mouse_lock: "Capturar mouse",
        volume: "Volume",
        pause: "Pausar",
        dosboxconf_template: "Modelo dosbox.conf:",
        preview: "Pré-visualizar",
        continue: "Continuar",
        skip: "Pular",
        loading: "Carregando",
        extract_loading: "Extraindo arquivo",
        extract_long_time: "Pode levar algum tempo, por favor, seja paciente...",
        theme: "Tema",
        create_empty: "Criar pacote vazio",
        uploading_file: "Enviando arquivo",
        fs_restart: "Você deseja reconstruir o pacote usando este sistema de arquivos?",
        please_wait: "Por favor, aguarde",
        making_bundle: "Criando pacote",
        size: "Tamanho",
        room: "Sala",
        server: "Servidor",
        load_by_url: "Carregar por URL",
        enter_url: "Digite a URL",
        load: "Carregar",
        stored: "Armazenado",
        delete: "Excluir",
        editor: "Editor",
        download: "Download",
        changes: "Salvamentos",
        loading_saves: "Carregando salvamentos",
        success: "Sucesso",
        success_save: "Salvo na nuvem",
        warn_save_no_account: "Salvo no navegador (você não está conectado)",
        warn_save_no_premium: "Salvo no navegador (sem assinatura)",
        warn_save_big_file: "Salvo no navegador (grande arquivo)",
        unable_to_save: "Não foi possível salvar",
        not_premium: "Assine",
        copy_net_link: "Compartilhe este link para se conectar",
        copied: "Copiado",
        image_rendering: "Renderização de imagem",
        fix: "Corrigir",
        close: "Fechar",
        cancle: "Cancelar",
        manage: "Gerenciar",
        unable_to_cancle_subscription: "Não foi possível cancelar a assinatura",
        subscription_cancelled: "Assinatura cancelada",
        hardware: "Aceleração de hardware",
        no_cloud_access: "Para usar o armazenamento em nuvem, insira",
        no_cloud_access2: "abaixo",
        no_cloud_access3: "Sem assinatura, seu progresso será salvo localmente no navegador e pode ser perdido",
        key: "sua chave",
        load_archive: "Carregar arquivo",
        sockdrives: "Imagens de disco (sockdrive)",
        confirm_save: "Você deseja salvar o progresso?",
        save: "Salvar",
        emulation_ended: "Emulação terminada",
        saving_game: "Salvando jogo...",
        sockdrive_save_in_the_middle: "Win9x é mais seguro salvar após desligar o sistema",
        changes_loaded: "Alterações carregadas no jogo",
        error_deleting_changes: "Erro ao deletar alterações",
        no_changes_loaded: "Nenhuma alteração carregada",
        upload: "Carregar",
        error_uploading_changes: "Erro ao carregar alterações",
        delete_changes_confirm: "Tem certeza que deseja deletar os salvamentos?",
        no_changes_to_save: "Nenhuma alteração para salvar",
    },
    ro: {
        click_to_lock: "Faceți clic pentru a captura mouse-ul",
        use_esc_key_to_unlock: "Folosește `Esc` pentru a debloca",
        use_slider_to_change_sensitivity: "Folosește cursorul din stânga pentru a schimba sensibilitatea",
        current_sensitivity: "Sensibilitatea în prezent",
        hello: "Salutare",
        hello_guest: "Salutare, oaspete!",
        play: "Pornește",
        system_cursor: "Cursorul sistemului",
        mobile_controls: "Comenzi mobile",
        mirrored_controls: "Comenzi oglindă",
        scale_controls: "Controale de scalare",
        enter_name_of_drive: "Introduceți numele unității",
        ws_outdated: "Trebuie să actualizați aplicația de browser DOS",
        update: "Actualizare",
        preloading_sockdrive: "Se încarcă (o dată)",
        filter: "Filtru",
        add: "Adaugă",
        logout: "Deconectare",
        features: "Caracteristici",
        premium: "Abonament",
        buy: "Cumpără",
        experimental_features: "Acces la toate funcțiile experimentale",
        cloud_saves: "Salvează în cloud",
        writeable_fat32: "FAT32 inscriptibil",
        net_no_limits: "Schimbați regiunea rețelei",
        unlock_options: "Deblocați toate opțiunile de configurare",
        error: "Ups... Ceva nu a mers bine...",
        consult_logs: "Vă rugăm să verificați jurnalele browserului",
        bundle_loading: "Pachetul se încarcă",
        bundle_config: "Citirea configurației",
        try_free: "zile gratuite",
        upload_file: "Selectați fișierul jsdos/zip pentru a începe...",
        emulation_backend: "Emulare",
        render_backend: "Randează",
        render_aspect: "Aspect",
        worker: "Fir de lucru",
        mouse_sensitivity: "Senzor mouse...",
        mouse_lock: "Captură mouse",
        volume: "Volum",
        pause: "Pauză",
        dosboxconf_template: "Șablon dosbox.conf:",
        preview: "Previzualizare",
        continue: "Continuați",
        skip: "Sari peste",
        loading: "Se încarcă",
        extract_loading: "Despachetarea arhivei",
        extract_long_time: "Poate dura mult timp, vă rog să aveți răbdare...",
        theme: "Temă",
        create_empty: "Creați un pachet gol",
        uploading_file: "Se încarcă fișierul",
        fs_restart: "Vrei să reconstruiești pachetul folosind acest fs?",
        please_wait: "Va rugăm așteptați",
        making_bundle: "Se creează pachetul",
        size: "Dimensiune",
        room: "Cameră",
        server: "Server",
        load_by_url: "Încărcare după URL",
        enter_url: "Introduceți adresa URL",
        load: "Încarcă",
        stored: "Stocat",
        delete: "Şterge",
        editor: "Editor",
        download: "Descărcare",
        changes: "Salvări",
        loading_saves: "Se încarcă salvările",
        success: "Succes",
        success_save: "Salvat în cloud",
        warn_save_no_account: "Salvat în browser (neconectat)",
        warn_save_no_premium: "Salvat în browser (fără abonament)",
        warn_save_big_file: "Salvat în browser (fișier mare)",
        unable_to_save: "Nu se poate salva",
        not_premium: "Abonează-te",
        copy_net_link: "Distribuiți acest link pentru a vă conecta",
        copied: "Copiat",
        image_rendering: "Redarea imaginilor",
        fix: "Reparare",
        close: "Închide",
        cancle: "Anulează",
        manage: "Gestionează",
        unable_to_cancle_subscription: "Nu se poate anula abonamentul",
        subscription_cancelled: "Abonament anulat",
        hardware: "Accelerare hardware",
        no_cloud_access: "Pentru a activa salvările în cloud, introduceți",
        no_cloud_access2: "dedesubt",
        no_cloud_access3: "Fără un abonament, progresul dvs. va fi salvat doar local în browser și se poate pierde.",
        key: "cheia ta",
        load_archive: "Încărcați arhiva",
        sockdrives: "Imagini de disc (unitate de tip sock)",
        confirm_save: "Vrei să salvezi progresul?",
        save: "Salvați",
        emulation_ended: "Emularea s-a încheiat",
        saving_game: "Se salvează jocul...",
        sockdrive_save_in_the_middle: "Este mai sigur să salvați fișierele în Win9x după închiderea sistemului.",
        changes_loaded: "Modificări încărcate în joc",
        error_deleting_changes: "Eroare la ștergerea modificărilor",
        no_changes_loaded: "Nicio modificare încărcată",
        upload: "Încărcați",
        error_uploading_changes: "Eroare la încărcarea modificărilor",
        delete_changes_confirm: "Sunteți sigur că doriți să ștergeți modificările?",
        no_changes_to_save: "Nu există modificări pentru a fi salvate",
    },
};

const initialLang = navigator.language.startsWith("ru") ? "ru" :
    (navigator.language.startsWith("pt") ? "pt" :
        (navigator.language.startsWith("ro") ? "ro" : "en"));


const initialState: {
    lang: "ru" | "en" | "pt" | "ro",
    keys: { [key: string]: string },
} = {
    lang: initialLang,
    keys: translations[initialLang],
};

export type I18NState = typeof initialState;

export const i18nSlice = createSlice({
    name: "i18n",
    initialState,
    reducers: {
        setLang: (state, action: { payload: "ru" | "en" | "pt" }) => {
            state.lang = action.payload;
            state.keys = translations[action.payload];
        },
    },
});

export function useT() {
    const keys = useSelector((state: State) => state.i18n.keys);
    return (key: string) => {
        return keys[key] ?? key;
    };
};

export function getT(state: State) {
    return (key: string) => {
        return state.i18n.keys[key] ?? key;
    };
};
